<div class="aside_title-section">
  <h1 class="title-dashboard">
    {{ 'ALARM.UNREADALARM' | translate }}
  </h1>
</div>

@if (permissionService.checkPermissionValue({ permission: 'READ', tab: 'alarm' })) {
  <div class="widget-content-height">
    @if (alarmLogsData$(); as alarmLogsData) {
      @if (alarmLogsData?.length === 0) {
        <div class="missing-data-dashboard">
          <p>{{ 'ALARM.NO_NOTIF' | translate }}</p>
        </div>
      } @else {
        @for (alarmData of alarmLogsData | slice: 0 : 5; track alarmData) {
          <alarm-log-card style="padding: 3px" [alarmLog]="alarmData" [isDisplayAlarmName]="true" />
        }
      }
      @if (alarmLogsData?.length > 5) {
        <div class="data-more-icon">
          <mat-icon (click)="goTo()" [matTooltip]="'COMMON.SEEMORE' | translate">more_horiz</mat-icon>
        </div>
      }
    } @else {
      <widget-loader />
    }
  </div>
} @else {
  <p class="not-allowed-text">
    {{ 'USER.NOT_ACCESS_DATA' | translate }}
    <br />
    {{ 'USER.PLEASECONTACTADMIN' | translate }}
  </p>
}
